import complaintTypes from "./complaintTypes.json";
import titles from "./titles.json";
import sources from "./sources.json";
import stages from "./stages.json";
import activityNoteTypes from "./activityNoteTypes.json";
import activityDocumentTypes from "./activityDocumentTypes.json";
import natureOfComplaint from "./natureOfComplaint.json";
import subNatureOfComplaint from "./subNatureOfComplaint.json";
import natureOfAllegation from "./natureOfAllegation.json";
import subNatureOfAllegation from "./subNatureOfAllegation.json";
import complaintOutcome from "./complaintOutcome.json";
import regulatoryActionTaken from "./regulatoryActionTaken.json";
import sourceOfAllegation from "./sourceOfAllegation.json";
import finalDetermination from "./finalDetermination.json";
import actionsArising from "./actionsArising.json";
import disclosureActionsTaken from "./disclosureActionsTaken.json";
import aoActions from "./aoActions.json";
import activityCommsTypes from "./activityCommsTypes.json";
import peopleAffected from "./peopleAffected.json";
import aoComplaint from "./aoComplaint.json";
import relationship from "./relationship.json";
import permission from "./permission.json";
import disclosureConsent from "./disclosureConsent.json";
import centreNumberType from "./centreNumberType.json";
import slas from "./slas.json";
import commsEnabled from "./commsEnabled.json";
import internalReviewOutcomes from "./internalReviewOutcomes.json";
import internalReviewReasons from "./internalReviewReasons.json";
import internalReviewActions from "./internalReviewActions.json";
import editReason from "./editReason.json";
import GqVtq from "./GqVtq.json";
import slaReason from "./slaReason.json";
import complaintStatus from "./complaintStatus.json";
export default {
    complaintTypes,
    titles,
    sources,
    stages,
    activityNoteTypes,
    activityDocumentTypes,
    natureOfComplaint,
    subNatureOfComplaint,
    natureOfAllegation,
    subNatureOfAllegation,
    complaintOutcome,
    regulatoryActionTaken,
    sourceOfAllegation,
    finalDetermination,
    actionsArising,
    disclosureActionsTaken,
    aoActions,
    activityCommsTypes,
    peopleAffected,
    aoComplaint,
    relationship,
    permission,
    disclosureConsent,
    centreNumberType,
    slas,
    commsEnabled,
    internalReviewOutcomes,
    internalReviewReasons,
    internalReviewActions,
    editReason,
    GqVtq,
    slaReason,
    complaintStatus
};
